import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraBadge } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useProject } from '../../hooks/useProjects';
/**
 * Header badge for a project-bound chat (a program Workroom chat opened in the
 * Assistant): names the project/program it belongs to, falling back to the
 * generic label while the name loads or when the caller cannot read the project.
 */ // specra-allow local-composite: Resolves the project name and renders the shared SpecraBadge.
export function ChatProjectBadge({ projectId }) {
    const { data } = useProject(projectId);
    const name = data?.project?.name;
    return /*#__PURE__*/ _jsx(SpecraBadge, {
        className: "flex-shrink-0 uppercase tracking-wide",
        "data-testid": Testids.assistant.chatProgramBadge,
        variant: "neutral",
        children: name || 'Project chat'
    });
}
